import React, { Component } from 'react';
import PropTypes from 'prop-types';

import {
  Box,
  Divider,
  Grid,
  Typography,
} from '@material-ui/core';

import i18n from '../../i18n';

import { productTierStyleMap } from '../../constants/general';

class BookingFormProductTierInfo extends Component {
  render(){
    const {
      productTier,
    } = this.props;

    return (
      <>
        <Grid item xs={3} className="bookingFormLabel">
          <Typography component="div">
            <Box fontSize="h5.fontSize" fontWeight="fontWeightBold">
              {i18n.t('booking:productTier')}
            </Box>
          </Typography>
        </Grid>
        <Grid item xs={8}>
          <p
            className={`bookingStaticField productTier ${productTierStyleMap[productTier]}`}
          >
            {productTier === 0 ? i18n.t('noData') : productTier}
          </p>
        </Grid>
        <Grid item xs={12}>
          <Divider className="form-divider" />
        </Grid>
      </>
    )
  }
}

BookingFormProductTierInfo.propTypes = {
  productTier: PropTypes.number.isRequired,
};

export default BookingFormProductTierInfo;
